import { j as r } from "./jsx-runtime-3tyXYecC.mjs";
import { f as i } from "./index-LyFokDcn.mjs";
import { m as s } from "./tss-DN0acMKN.mjs";
const t = s()(({ borderRadiuses: e, layout: o, palette: a }) => ({
  root: {
    backgroundColor: a.grey[50],
    borderRadius: e[600],
    boxSizing: "border-box",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    minWidth: "100%",
    /*
     * This is necessary to allow children to use `position: sticky`. Setting `overflow: hidden` will break `position: sticky`.
     * The previous implementation used `contain: paint` but it prevents content from expanding the capsule without also using `width: fit-content`.
     */
    overflow: "clip",
    padding: `${o.pageCapsule.padding}px`,
    "@media print": {
      background: "none"
    }
  }
}));
function d(e) {
  const { classes: o } = t(), { id: a = "page-capsule", children: n } = e;
  return /* @__PURE__ */ r.jsx(r.Fragment, { children: i.ifFeature(
    "encore",
    /* @__PURE__ */ r.jsx("div", { className: o.root, "data-fabric-component": "PageCapsule", id: a, children: n }),
    "PageCapsule component is only available with Encore enabled."
  ) });
}
export {
  d as P
};
//# sourceMappingURL=page-capsule-DwjIzTdE.mjs.map
